import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import styles from "./styles.css";
import Tab from "./Tab";

const Tabs = ({ className, panes, disabled = false }) => {
	const { search, pathname } = useLocation();
	const history = useHistory();
	const [ selectedTab, setSelectedTab ] = useState();

	useEffect(() => {
		if (search) {
			const tab = new URLSearchParams(search).get("tab");
			const paneIndex = panes.findIndex(
				p => p.menuItem.toLowerCase() === tab
			);
			if (tab && paneIndex >= 0) {
				setSelectedTab(paneIndex + 1);
			}
		} else {
			setSelectedTab(1);
		}
	}, [ panes, search ]);

	const handleKeyPress = event => {
		const tabCount = panes.length;

		if (event.key === "ArrowLeft") {
			const last = tabCount;
			const next = selectedTab - 1;
			handleNextTab(last, next, 1);
		}
		if (event.key === "ArrowRight") {
			const first = 1;
			const next = selectedTab + 1;
			handleNextTab(first, next, tabCount);
		}
	};

	const handleNextTab = (firstTabInRound, nextTab, lastTabInRound) => {
		const tabToSelect =
            selectedTab === lastTabInRound ? firstTabInRound : nextTab;
		selectTab(tabToSelect);
		setTimeout(() => {
			if (panes[tabToSelect - 1]?.ref?.current) {
				panes[tabToSelect - 1].ref.current.focus();
			}
		}, 200);
	};

	const selectTab = tab => {
		let params = new URLSearchParams(search);
		const paneName = panes[tab - 1].menuItem?.toLowerCase();
		if (paneName) {
			params.set("tab", paneName);
			history.push({
				pathname: pathname,
				search: params.toString(),
			});
		}
	};

	return (
		<section className={`${className} ${styles.tabsWrapper}`}>
			<div className={styles.switcher}>
				<ul
					role="tablist"
					className={`${styles.tablist} ${styles.switcher ? styles.switcher : ""}`}
					aria-label="Tabs"
					onKeyDown={handleKeyPress}
				>
					{panes?.map((tab, index) => {
						const ariaControlsAttr = selectedTab === index + 1 ? { [`aria-controls`]: `tabPanel${index}` } : {};

						return (
							<Tab
								id={`tab${index}`}
								index={index + 1}
								handleChange={selectTab}
								title={tab.menuItem}
								disabled={disabled}
								ref={tab.ref}
								ariaSelected={selectedTab === index + 1}
								ariaControls={ariaControlsAttr}
								tabIndex={selectedTab === index + 1 ? 0 : -1}
							/>
						);
					})}
				</ul>
			</div>
			{panes?.map((tab, index) => {
				return (
					selectedTab === index + 1 && (
						<section
							role="tabpanel"
							aria-label={tab.menuItem}
							id={`tabPanel${index}`}
							className={tab.className ?? ""}
						>
							{tab.render()}
						</section>
					)
				);
			})}
		</section>
	);
};

export default Tabs;
